import { Link } from "react-router-dom";
import Icon from "@/components/feature/Icon";

export default function EventsCTA() {
  return (
    <section className="py-20 md:py-28 bg-navy-950 relative overflow-hidden">
      {/* Subtle grid pattern */}
      <div className="absolute inset-0 opacity-5">
        <svg className="w-full h-full" viewBox="0 0 800 400" preserveAspectRatio="none">
          <defs>
            <pattern id="events-cta-grid" width="60" height="60" patternUnits="userSpaceOnUse">
              <circle cx="30" cy="30" r="1" fill="white" />
            </pattern>
          </defs>
          <rect width="800" height="400" fill="url(#events-cta-grid)" />
        </svg>
      </div>

      <div className="relative z-10 px-6 md:px-10 lg:px-16">
        <div className="max-w-4xl mx-auto text-center">
          <p className="text-sm font-medium tracking-[0.2em] text-silver-400 uppercase mb-4">
            Stay Connected
          </p>
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-semibold text-white leading-tight mb-6">
            不錯過任何重要資訊
          </h2>
          <p className="text-silver-300 text-base md:text-lg leading-relaxed max-w-2xl mx-auto mb-10">
            加入 TAIAA 會員，即可享有活動優先報名權、專屬講座與產業報告。訂閱電子報，掌握最新活動與產業趨勢。
          </p>

          <div className="flex flex-wrap justify-center gap-4">
            <Link
              to="/membership"
              className="inline-flex items-center gap-2 bg-white text-navy-950 px-7 py-3.5 rounded-full text-sm font-medium hover:bg-silver-100 transition-colors whitespace-nowrap"
            >
              加入會員
              <Icon className="ri-arrow-right-line" />
            </Link>
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 border border-white/30 text-white px-7 py-3.5 rounded-full text-sm font-medium hover:bg-white/10 transition-colors whitespace-nowrap"
            >
              聯絡我們
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}